module.exports = __webpack_public_path__ + "static/media/17.f384ed8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/17.jpg
// module id = 192
// module chunks = 0